import Home from './routes/Home';
import About from './routes/About';
import Service from './routes/Service';
import Project from './routes/Projects';
import Contact from './routes/Contact';
import Termsandcondition from './routes/Termsandcondition';
import Privacypolicy from './routes/Privacypolicy';
import Notfound from './routes/Notfound';
import { Routes , Route } from 'react-router-dom';
function App() {
  return (
   <>
   <Routes>
    <Route path='/' element={<Home />}/>
    <Route path='/about' element={<About />}/>
    <Route path='/contact' element={<Contact />}/>
    <Route path='/service' element={<Service />}/>
    <Route path='/projects' element={<Project />}/>
    <Route path='*' element={<Notfound />}/>
    <Route path='/termsandcondition' element={<Termsandcondition/>}/>
    <Route path='/privacypolicy' element={<Privacypolicy/>}/>
   </Routes>
   </>
  );
}

export default App;
